<template lang="pug">
    v-container(class="px-2 py-0")
        v-row(v-if="!floorPlans" no-gutters)
            v-col()
                v-card(outlined elevation="-1" class="tw-shadow-inner tw-border-gray-600" color=" blue-grey lighten-5 " @click="addFloorPlans")
                    v-row(no-gutters class="ma-8" justify="center")
                        v-col(class="text-center")
                            div 
                                v-icon(x-large ) mdi-plus-thick
                            div
                                span(class=" grey--text text--darken-1") Add floor plans
                    
        v-row(v-else no-gutters)
            v-col
                |SHOW FLOR PLANS 
        
</template>
<script>
    export default {
        data() {
            return {
                floorPlans: false,
            }
        },
        methods: {
            addFloorPlans(){
                console.log("this is a test")
            }
        },
    }
</script>